// extracted by mini-css-extract-plugin
export default {"Paragraph":"Home_Paragraph__VZCUH","PaddingLess":"Home_PaddingLess__B3V7Z","Subheader":"Home_Subheader__Q-z85","Header":"Home_Header__6qjqu"};